(() => {
  if (customElements.get('localization-form')) return;
/* Initialize on connection: sections and AJAX fragments can be created before
 * their child nodes exist. Keep language and country selections independent. */
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.onOpen = this.openSelector.bind(this);
    this.onClose = this.closeSelector.bind(this);
    this.onKey = this.onContainerKeyUp.bind(this);
    this.onSelect = this.onItemClick.bind(this);
  }

  connectedCallback() {
    this.initialize();
    if (!this.initialized) {
      this.childObserver = new MutationObserver(() => this.initialize());
      this.childObserver.observe(this, { childList: true, subtree: true });
    }
  }

  initialize() {
    if (this.initialized || !this.isConnected) return;
    const input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
    const button = this.querySelector('button');
    const panel = this.querySelector('.disclosure_element');
    if (!input || !button || !panel) return;
    this.elements = { input, button, panel };
    this.initialized = true;
    if (this.childObserver) this.childObserver.disconnect();
    button.addEventListener('click', this.onOpen);
    this.addEventListener('focusout', this.onClose);
    this.addEventListener('keyup', this.onKey);
    // Delegation also supports options inserted by a theme-editor refresh.
    this.addEventListener('click', this.onSelect);
  }

  disconnectedCallback() {
    if (this.childObserver) this.childObserver.disconnect();
    if (!this.initialized) return;
    this.elements.button.removeEventListener('click', this.onOpen);
    this.removeEventListener('focusout', this.onClose);
    this.removeEventListener('keyup', this.onKey);
    this.removeEventListener('click', this.onSelect);
    this.initialized = false;
  }

  hidePanel() {
    if (!this.initialized) return;
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', '');
  }

  onContainerKeyUp(event) {
    if (event.key !== 'Escape' && event.code !== 'Escape') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    const item = event.target.closest && event.target.closest('a[data-value]');
    if (!item || !this.contains(item) || !this.initialized) return;
    const form = item.closest('form') || this.querySelector('form');
    if (!form || !item.dataset.value) return;
    event.preventDefault();
    this.elements.input.value = item.dataset.value;
    // Preserve Shopify's localization POST, return_to, and the selected market.
    HTMLFormElement.prototype.submit.call(form);
  }

  openSelector(event) {
    if (!this.initialized) return;
    if (event) event.preventDefault();
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', String(!this.elements.panel.hasAttribute('hidden')));
  }

  closeSelector(event) {
    if (!this.contains(event.relatedTarget)) this.hidePanel();
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}

})();
